import React from 'react';

const Callback = () => <p>Loading</p>;

export default Callback;
